/**
 * Презентационные хелперы «Платежей» — чистые функции, без React.
 */

import dayjs from 'dayjs';

import type {PaymentRow, PaymentStatus} from '@services/payments';
import {formatNumber} from '@utils/format';

/** Сумма со знаком: «690 000» / «−12 000» (минус — U+2212). */
export const fmtSignedSom = (n: number): string => (n < 0 ? '−' : '') + formatNumber(Math.abs(n));

/** Цвет суммы: возврат — янтарный, неудача — приглушённый, иначе — основной. */
export const amountClass = (row: Pick<PaymentRow, 'amount' | 'status'>): string => {
  if (row.amount < 0) return 'text-skr-warn';
  if (row.status === 'failed') return 'text-skr-faint';
  return 'text-foreground';
};

export const fmtRowDate = (iso: string): string => dayjs(iso).format('D MMM YYYY').replace('.', '');

export const fmtDayLabel = (iso: string): string => dayjs(iso).format('D MMMM YYYY');

export type PaymentGroup = {date: string; label: string; rows: PaymentRow[]};

/** Группировка строк по дню (для мобильного списка), порядок сохраняется. */
export const groupByDay = (rows: PaymentRow[]): PaymentGroup[] => {
  const groups: PaymentGroup[] = [];
  for (const row of rows) {
    const last = groups[groups.length - 1];
    if (last && last.date === row.date) last.rows.push(row);
    else groups.push({date: row.date, label: fmtDayLabel(row.date), rows: [row]});
  }
  return groups;
};

export const STATUS_FILTER_OPTIONS: {value: PaymentStatus; label: string; dot: string}[] = [
  {value: 'success', label: 'Успешно', dot: '#1B7A54'},
  {value: 'pending', label: 'В обработке', dot: '#2C5CDB'},
  {value: 'failed', label: 'Неудачно', dot: '#C6362C'},
  {value: 'refund', label: 'Возврат', dot: '#B07908'},
];
